import React, {  } from 'react';

import { pluralRulesOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { SelectInput } from './Intl.PluralRules';

export const IntlPluralRulesSelect = () => (
	<IntlFunction
		input={SelectInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/select"
		header="Intl.PluralRules.prototype.select"
		description="Returns a string indicating which plural rule to use for locale-aware formatting."
		options={pluralRulesOptions}
		ruleSet={[]}
		template="new Intl.PluralRules(##locale##, ##options##).select(##input:raw##)" />
)